import * as React from 'react';
import { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { CandidateContext } from './Context';
import { API_URI } from './Constants';
import axios from 'axios';
import { Modal, Box, TextField, Button, Typography } from '@mui/material';
import axiosInstance from '../Api/Instance';

export default function Dropdown(props) {
  const { isJDChecked, applied_position, setApplied_position, positions, application_status, setApplication_status, applicant_status,setPositions } = React.useContext(CandidateContext);
  const { dropdown, isReset, roles,setRoles, changeRole =false } = props;
  const dropdownFor = dropdown === "addProfile" ? roles : applicant_status;
  // const [options, setOptions] = React.useState(dropdownFor);

  // const [options, setOptions] = useState([...dropdownFor, 'Add Role']);
  
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [newRole, setNewRole] = useState('');

  const rolewithoutid = positions.filter((item)=> item.role)
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
  if (isReset) {
    setApplied_position('');
  }

  if (dropdown === 'addProfile' && changeRole === true) {
    const roleWithoutId = positions.map((item) => item.code);
    setOptions([...roleWithoutId]);
  } else if (dropdown === 'addProfile') {
    setOptions([...roles]);
  } else {
    const status = applicant_status.map((detail,i)=> detail.label)
    setOptions(status);
  }
}, [isReset, dropdown, changeRole, roles, positions, applicant_status]);

  const handleChange = (event) => {
    if (dropdown === "addProfile") {
        setApplied_position(event.target.value);
        return;
}
    if (dropdown === "applicantStatus") {
      setApplication_status(event.target.value);
      return;
    }
  };


  // const handleSubmit = async () => {
  //   try {
  //     const response = await axiosInstance.post(`/addCandidateRole`, {
  //       role: newRole.trim()
  //     },
  //       { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  //       const newRoles = response?.data?.role.map(item=>item.role)
  //       setRoles(newRoles);
  //       setPositions(response?.data?.role)
  //     setOpen(false)
  //   } catch (err) {
  //     if (err.response?.status === 409) {
  //       alert('Role already exists.');
  //     } else {
  //       console.error('Error adding role:', err);
  //       alert('Something went wrong. Please try again.');
  //     }
  //   }
  // }

  return (

    <FormControl sx={{ minWidth: 200 }} size="small" className="mr-2" required={(dropdown === "addProfile" && !isJDChecked) ? true : false}>
      {/* <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Add New Role
          </Typography>
          <TextField
            fullWidth
            label="Role Name"
            variant="outlined"
            value={newRole}
            onChange={(e) => setNewRole(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={() => setOpen(false)} variant="outlined" color="secondary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </Box>
      </Modal> */}
      <InputLabel id="demo-select-small-label">{dropdown === "addProfile" ? "Role" : "Status"}</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={dropdown === "addProfile" ? applied_position : application_status}
        label={dropdown === "addProfile" ? "Role" : "Status"}
        onChange={handleChange}
        disabled={props.disabled}
      >
        {options.map((option, i) => (
          <MenuItem
            value={option}
            key={i + 1}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>


  );
}
